<div class="dls-header w-100" [ngClass]="{ 'no-toggle': noToggle || !toggle, 'no-header': hideHeader }">

  <mat-toolbar class="d-lg-none px-2 mat-elevation-z4">
    <!-- Side navigation toggle -->
    <button atlas-icon-button
      class="me-3"
      (click)="sideNav.toggle()"
      aria-label="Side Navigation menu">
      <mat-icon>menu</mat-icon>
    </button>

    <div class="d-flex flex-row align-items-center dls-cursor-pointer" routerLink="/home" tabindex="0">
      <!-- WellSky Crown Logo -->
      <img
        class="ws-logo-crown d-md-none"
        [src]="headerMobileSource"
        alt="WellSky Logo Crown">

      <img
        class="ws-logo-crown d-md-block d-none"
        [src]="headerTabletSource"
        alt="WellSky Logo Crown">
    </div>
  </mat-toolbar>

  <div class="d-flex flex-column flex-md-row justify-content-md-between py-3 py-lg-4 px-3 px-lg-5" *ngIf="!hideHeader">
    <!-- Page Heading -->
    <div class="w-100 d-flex align-items-center justify-content-between mb-2 mb-md-0">
      <span class="d-flex flex-grow-1 mat-display-1 m-0">
        {{heading}}
      </span>

      <!-- Toggle Theme -->
      <atlas-menu-trigger [atlasMenuTrigger]="atlasMenu">
        <button
        atlas-icon-button
        color="accent"
        atlasTooltip="Select a theme"
        aria-label="Select a theme"
        >
          <mat-icon>format_color_fill</mat-icon>
        </button>
      </atlas-menu-trigger>

      <atlas-menu #atlasMenu="atlasMenu">
        <ng-template atlas-menu-item>
          <button (click)="toggleTheme('light')">
            Light Theme
          </button>
        </ng-template>
        <ng-template atlas-menu-item>
          <button (click)="toggleTheme('dark')">
            Dark Theme - &beta;eta
          </button>
        </ng-template>
      </atlas-menu>
    </div>

    <!-- Design & Develop Toggle -->
    <div class="justify-content-end ms-4"
      [ngClass]="{
        'd-none': noToggle || !toggle,
        'd-flex': !(noToggle || !toggle)
      }" >
      <!-- Toggle develop/design sections -->
      <mat-button-toggle-group
        name="toggle"
        [value]="toggle"
        [disabled]="isToggleDisabled"
        (change)="toggleChange($event)"
        appearance="standard">
        <mat-button-toggle value="develop">
          Develop
        </mat-button-toggle>
        <mat-button-toggle value="design">
          Design
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <mat-divider color="accent" *ngIf="!hideHeader"></mat-divider>

  <!-- Page Tabs -->
  <div class="dls-page-tab-container" *ngIf="!hideHeader">
    <dls-page-tabs *ngIf="pageTabs.length" [pageTabs]="pageTabs"></dls-page-tabs>
  </div>

   <!-- Atlas Banner -->
   <atlas-banner-container></atlas-banner-container>
</div>
